import { MY_LISTS_ACTIONS } from '../actions/ActionConstants';

const myLists = (state = { open: false, selected: 'favorites' }, action) => {
    switch (action.type) {
        case MY_LISTS_ACTIONS.openFavorites:
            return { ...state, open: true, selected: 'favorites' };
        case MY_LISTS_ACTIONS.openRecents:
            return { ...state, open: true, selected: 'recents' };
        case MY_LISTS_ACTIONS.openCollections:
            return { ...state, open: true, selected: 'collections' };
        case MY_LISTS_ACTIONS.closePanel:
            return { ...state, open: false };
        default:
            return state;
    }
};

export default myLists;
